import { Directive, ElementRef, OnInit , Input } from '@angular/core';
import { CustomAuthenticationService } from '../../auth/services/custom-authentication.service';
import { AuthGroup } from '../../auth/services/authorization.types';

@Directive({
    selector: '[myHideIfUnauthorized]'
})
export class MyHideIfUnauthorizedDirective implements OnInit {
    @Input('myHideIfUnauthorized') permission: AuthGroup; // Required permission passed in

    constructor(private el: ElementRef, private authorizationService: CustomAuthenticationService) { }

    ngOnInit() {
        if (!this.authorizationService.hasPermission(this.permission)) {
            this.el.nativeElement.style.display = 'none';
        }
    }
}